export default "__VITE_PUBLIC_ASSET__7a27d318__"